export default __webpack_public_path__ + "static/bubble-c3af6e92832b1017078c6c6cc24d430c.jpg";